import { CS } from "../../../../../base/utils/styler"

export const inputsStyle: CS = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'center',
    paddingTop: '90px',
}

export const bannerGroupStyle: CS = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '10px',
    gap: '20px'
}
